module.exports = __webpack_public_path__ + "img/defaultVideoBg.3441e308.png";